import { Conversion } from "@/components/Price/price/components/conversion";
import { Main } from "@/components/Price/price/components/main";
import { StrikeThrough } from "@/components/Price/price/components/strikeThrough";
import { Base } from "@/components/Price/price/price.base";

export const Price = Object.assign(Base, {
    Main: Main,
    StrikeThrough: StrikeThrough,
    Conversion: Conversion
});
